// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KNAt","right":"styles_right__15C1m"};